import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

/** Confirms switching a feature off. `feature` is a FEATURE_DEFINITIONS entry (or null when closed). */
const FeatureOffConfirmDialog = ({ feature, scopeLabel, onCancel, onConfirm }) => (
  <Dialog open={!!feature} onClose={onCancel} fullWidth maxWidth="xs">
    <DialogTitle>Turn off {feature?.label} {scopeLabel}?</DialogTitle>
    <DialogContent>
      <DialogContentText>{feature?.offWarning}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button onClick={onConfirm} color="error" variant="contained">Turn off</Button>
    </DialogActions>
  </Dialog>
);

export default FeatureOffConfirmDialog;
